import { Box, Chip, Stack, Typography, useTheme } from "@mui/material";
import { ForecastGrade } from "./ForecastGrade";
import { ForecastAnalytics } from "@domain/forecast/models/ForecastAnalytics";
import { addTransparency } from "../../../../application/styles/colorStyles";

interface ForecastGradeSummaryProps {
    forecastAnalytics?: ForecastAnalytics;
}

export const ForecastGradeSummary = ({ forecastAnalytics }: ForecastGradeSummaryProps) => {
    const theme = useTheme();


    const getErrorColor = (error: number): string => {
        error = Math.abs(error);

        if (error > 0.3) return theme.palette.error.main;
        if (error > 0.2) return theme.palette.warning.main;
        if (error > 0.1) return '#FFCC00';
        if (error > 0) return theme.palette.success.main;
        return theme.palette.grey[500];
    }

    return (
        <Stack direction="column" spacing={2} sx={{ flex: 1, backgroundColor: "#F2F9FF", borderRadius: 2, p: 4 }}>
            <Typography variant="subtitle1" color="text.primary">Forecast Grade</Typography>

            <Stack direction="row" alignItems="center" spacing={2}>
                <ForecastGrade size="large" grade={forecastAnalytics?.grade} showLabel={true} grade_reasons={forecastAnalytics?.grade_reasons} />
            </Stack>


            {forecastAnalytics?.me !== undefined && !isNaN(forecastAnalytics?.me) && (
                <Stack direction="row" spacing={2} alignItems="center">
                    <Typography variant="body2" color="text.secondary">Average {Math.abs(forecastAnalytics.me).toFixed(0)} {forecastAnalytics.me > 0 ? 'above' : 'below'} actual sales</Typography>

                    {forecastAnalytics.me_scaled !== undefined && !isNaN(forecastAnalytics.me_scaled) && (
                        <div
                            style={{
                                backgroundColor: addTransparency(getErrorColor(forecastAnalytics.me_scaled), 0.2),
                                padding: '2px 8px',
                                borderRadius: '100px',
                                color: getErrorColor(forecastAnalytics.me_scaled),
                            }}
                        >
                            <Typography variant="caption" color="inherit">
                                {Math.abs(forecastAnalytics.me_scaled * 100).toFixed(1)}%
                            </Typography>
                        </div>
                    )}
                </Stack>
            )}
        </Stack>

    );
};